import React from 'react';

import { Box } from '@chakra-ui/react';
import ProfileFieldCard from './ProfileFieldCard';
import { useUser } from '../../../../hooks/V2/useUser';

const MobileNumber = () => {
	const { data: profile } = useUser();
	return (
		<Box>
			<ProfileFieldCard keyName="phone" title={profile?.phoneNumber ? '+91 ' + profile?.phoneNumber : ''} heading="Mobile Number" />
		</Box>
	);
};

export default MobileNumber;
